import { Component, OnInit } from '@angular/core';
import { PageInfoService } from '../../services/page-info.service';
import { PageInfo } from 'shared';

import { PageHeaderComponent } from '../../../../../shared/src/lib/components/page-header/page-header.component';
import { PageContainerComponent } from '../../../../../shared/src/lib/components/page-container/page-container.component';
import { TileComponent } from '../../../../../shared/src/lib/components/tile/tile.component';
import { ButtonComponent } from '../../../../../shared/src/lib/components/button/button.component';
import { RouterLink } from '@angular/router';
import { TableComponent } from '../../../../../shared/src/lib/components/table/table.component';
import { TableHeaderComponent } from '../../../../../shared/src/lib/components/table-header/table-header.component';
import { TableRowComponent } from '../../../../../shared/src/lib/components/table-row/table-row.component';
import { TableCellComponent } from '../../../../../shared/src/lib/components/table-cell/table-cell.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-mixit-subscription-overview',
    templateUrl: './mixit-subscription-overview.component.html',
    styleUrls: ['./mixit-subscription-overview.component.scss'],
    imports: [PageHeaderComponent, PageContainerComponent, TileComponent, ButtonComponent, RouterLink, TableComponent, TableHeaderComponent, TableRowComponent, TableCellComponent, TranslateModule]
})
export class MixitSubscriptionOverviewComponent implements OnInit {
  public pageInfo: PageInfo;

  constructor(private pageInfoService: PageInfoService) { }

  ngOnInit(): void {
    this.pageInfo = this.pageInfoService.mixitSubscriptionOverviewPage();
  }

}
